import { translateFun } from "../Translation";

export default function ImageModal(props) {
  const { React, AppContext, PartsAccList, open, handleClose, ZoomImage, Datasheet, PublishMessageAddToProject,
    PublishMessageClose, lang, PublishMessageSolution,PublishMessageSolutionConsoleEvent,PartId } = props

  const { useContext, useEffect, useState } = React;
  let {
    productForImageModal,
    setProductForImageModal,
    imageModalLoader,
    setImageModalLoader,
    Modal,
    Box,
    Typography,
    HighlightOff: HighlightOffIcon
  } = useContext(AppContext);



  const [renderView, setRenderView] = useState("image");
  const [productData, setProductData] = useState({});
  const [countryLang, setCountryLang] = useState("US_en");
  useEffect(() => {
    const langSplit = lang?.split("_")
    setCountryLang(`${langSplit[1]}_${langSplit[0]}`)
  }, [lang])
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  useEffect(() => {
    setProductData({});
    setProductData(productForImageModal);
    if (productForImageModal?.TECHNICAL_DIMENTION &&
      productForImageModal?.TECHNICAL_DIMENTION[0]) {
      setRenderView("illustrationImage");
    } else if (
      productForImageModal.VIEW_360_SET_OF_IMAGE || productForImageModal.TECHNICAL_DIAGRAM_FETURES || productForImageModal.MAIN_IMAGE_OF_PRODUCT
    ) {
      setRenderView("image");
    } else if (
      productForImageModal?.DatasheetObj
    ) {
      setRenderView("ProductInfo");
    } else {
      setRenderView("image");
    }
    setImageModalLoader(false);
  }, [productForImageModal]);

  // useEffect(() => {
  //   setProductData({});
  //   setProductData(productForImageModal);
  //   if (productForImageModal.VIEW_360_SET_OF_IMAGE || productForImageModal.TECHNICAL_DIAGRAM_FETURES || productForImageModal.MAIN_IMAGE_OF_PRODUCT) {
  //     setRenderView("image");
  //   } else if (
  //     productForImageModal?.TECHNICAL_DIMENTION &&
  //     productForImageModal?.TECHNICAL_DIMENTION[0]
  //   ) {
  //     setRenderView("illustrationImage");
  //   } else if (
  //     productForImageModal?.DatasheetObj
  //   ) {
  //     setRenderView("ProductInfo");
  //   } else {
  //     setRenderView("image");
  //   }
  //   setImageModalLoader(false);
  // }, [productForImageModal]);

  // useEffect(()=>{

  // },[productData])

  const handleCloseImageModal = () => {
    setProductData({});
    setProductForImageModal({});
  };

  const handleChangeView = () => {
    setImageModalLoader(true);
    // setLoading(true)
    setTimeout(() => {
      setImageModalLoader(false);
    }, 1);
  };
  

    return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="Image_Modal">
          <div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }} component="div">
              <>
                <div className="catalog_details">
                  <PartsAccList param="imageModal" PartId={PartId} React={React} AppContext={AppContext} PublishMessageAddToProject={PublishMessageAddToProject} PublishMessageSolution={PublishMessageSolution}
                    PublishMessageClose={PublishMessageClose}  PublishMessageSolutionConsoleEvent={PublishMessageSolutionConsoleEvent}/>
                </div>
                <div className="catalog_image">
                  <div className="main_render_div">
                    <div className="top-hrader">
                      <div className="cat-info">
                        <img src={productData.Image_Url} alt="" />
                        <div className="left-download-img">
                          <label>
                            {productData?.Catalog}
                            {/* {
                              productData?.Datasheet_Url ? <span data-toggle="tooltip" data-placement="right" title="Open datasheet" onClick={() => window.open(productData?.Datasheet_Url)}>
                                <img src={process.env.PUBLIC_URL + "/asset/images/download1.svg"} />
                              </span> : <></>
                            } */}
                            {/*
                              For Datasheet we can use https://eref.se.com/us/en/scope/product/ or https://www.se.com/us/en/product/download-pdf/
                            */}
                            {productData?.Datasheet_Url ? 
                              <button className="datasheetButton" onClick={() => window.open(`${productData.Datasheet_Url}`)}>
                                {translateFun("Datasheet")}
                                <span>
                                  <svg width="15" height="15" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.5688 0.865039C17.5688 0.848633 17.5688 0.832227 17.5664 0.818164C17.5664 0.811133 17.5641 0.804101 17.5641 0.794726C17.5617 0.785352 17.5617 0.77832 17.5594 0.768945C17.5571 0.75957 17.5547 0.752539 17.5524 0.743164C17.55 0.736133 17.5477 0.729102 17.5477 0.719727C17.5453 0.712695 17.543 0.70332 17.5383 0.696289C17.536 0.689258 17.5336 0.682227 17.5289 0.672852C17.5266 0.66582 17.5219 0.658789 17.5196 0.651758C17.5149 0.644727 17.5125 0.635352 17.5078 0.62832C17.5031 0.621289 17.5008 0.614258 17.4961 0.607226C17.4914 0.600195 17.4867 0.593164 17.4821 0.586133C17.4774 0.579102 17.4727 0.572071 17.4657 0.565039C17.461 0.558008 17.4563 0.55332 17.4516 0.546289C17.4422 0.53457 17.4305 0.522852 17.4188 0.511133C17.4188 0.511133 17.4188 0.511133 17.4188 0.508789C17.4071 0.49707 17.3953 0.487695 17.3836 0.475977C17.3766 0.471289 17.3719 0.466602 17.3649 0.461914C17.3578 0.457227 17.3508 0.450195 17.3438 0.445508C17.3367 0.44082 17.3297 0.436133 17.3227 0.431445C17.3156 0.426758 17.3086 0.424414 17.3016 0.419726C17.2946 0.415039 17.2852 0.412695 17.2782 0.408008C17.2711 0.405664 17.2641 0.400977 17.2571 0.398633C17.25 0.396289 17.243 0.393946 17.2336 0.389258C17.2266 0.386914 17.2172 0.382227 17.2102 0.379883C17.2031 0.377539 17.1938 0.375195 17.1867 0.372851C17.1774 0.370508 17.1703 0.368164 17.161 0.365821C17.1516 0.363477 17.1422 0.363476 17.1352 0.361133C17.1281 0.361133 17.1211 0.358789 17.1141 0.358789C17.0977 0.356445 17.0813 0.356445 17.0649 0.356445H11.6227C11.3438 0.356445 11.1188 0.581445 11.1188 0.860352C11.1188 1.13926 11.3438 1.36426 11.6227 1.36426H15.8485L10.4016 6.81816C10.2047 7.01504 10.2047 7.33379 10.4016 7.53066C10.5 7.6291 10.6289 7.67832 10.7578 7.67832C10.8867 7.67832 11.0156 7.6291 11.1141 7.53066L16.561 2.08379V6.19473C16.561 6.47363 16.786 6.69863 17.0649 6.69863C17.3438 6.69863 17.5688 6.47363 17.5688 6.19473V0.865039Z" fill="white" />
                                    <path d="M14.3883 17.6697H0.970337C0.691431 17.6697 0.466431 17.4447 0.466431 17.1658V3.74785C0.466431 3.46895 0.691431 3.24395 0.970337 3.24395H10.0219C10.3008 3.24395 10.5258 3.46895 10.5258 3.74785C10.5258 4.02676 10.3008 4.25176 10.0219 4.25176H1.47424V16.6619H13.8844V7.8377C13.8844 7.55879 14.1094 7.33379 14.3883 7.33379C14.6672 7.33379 14.8922 7.55879 14.8922 7.8377V17.1658C14.8922 17.4447 14.6672 17.6697 14.3883 17.6697Z" fill="white" />
                                  </svg></span>
                              </button> : <></>}

                          </label>
                          <p>{productData?.Description}</p>
                        </div>

                      </div>
                      {/* start code for right side download button */}

                      {/* <div className="right-content">
                        {
                          productData?.Datasheet_Url ? <span data-toggle="tooltip" data-placement="right" title="Open datasheet" onClick={() => window.open(productData?.Datasheet_Url)}>
                            <img src={process.env.PUBLIC_URL + "/asset/images/download1.svg"} />
                          </span> : <></>
                        } */}

                      {/* end code for right side download button */}

                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="div"
                        className="image_title_div"
                      >
                        {/* <h2 className="image_title">2545</h2> */}
                        <span
                          onClick={() => {
                            handleClose();
                            handleCloseImageModal();
                          }}
                        >
                          {" "}
                          {translateFun("Press")} <span className="clsEsc">Esc</span> {translateFun("toExit")} |{" "}
                          <button className="closeButton">
                          {translateFun("Close")} <HighlightOffIcon />
                          </button>
                        </span>
                      </Typography>

                      {/* start code for right side download button */}
                      {/* </div> */}
                      {/* end code for right side download button */}
                    </div>

                    <div className="render_view">
                      {imageModalLoader ? (
                        <></>
                      ) : renderView === "360view" ? (
                        <iframe
                          title="360View"
                          crossOrigin="true"
                          height="80%"
                          width="100%"
                          style={{ display: "flex", placeItems: "center" }}
                          src={
                            productData &&
                            productData.VIEW_360_SET_OF_IMAGE &&
                            productData.VIEW_360_SET_OF_IMAGE[0]
                          }
                        ></iframe>
                      ) : renderView === "ProductInfo" ? (
                        <Datasheet productData={productData} {...props} />
                      ) : (
                        <ZoomImage
                          imgsrc={
                            renderView === "image"
                              ? (productData?.MAIN_IMAGE_OF_PRODUCT ? productData?.MAIN_IMAGE_OF_PRODUCT  : productData.Image_Url)
                              : renderView === "illustrationImage"
                                ? productData?.TECHNICAL_DIMENTION &&
                                productData?.TECHNICAL_DIMENTION[0]
                                : renderView === "WiringDiagram"
                                  ? productData?.TECHNICAL_DIAGRAM &&
                                  productData?.TECHNICAL_DIAGRAM[0]
                                  : renderView === "TechnicalFetures"
                                    ? productData?.TECHNICAL_DIAGRAM_FETURES &&
                                    productData?.TECHNICAL_DIAGRAM_FETURES[0]
                                    : productData.Image_Url
                          }
                          {...props}
                        />
                      )}
                      <div className="thumbnails_div">
                        <div className="thumbnails_icon">
                          {productData?.TECHNICAL_DIMENTION &&
                            productData?.TECHNICAL_DIMENTION[0] ? (
                            <div
                              className={
                                renderView === "illustrationImage"
                                  ? "thumbnails__item-content--active "
                                  : "thumbnails__wrapper"
                              }
                              onClick={() => {
                                setRenderView("illustrationImage");
                                handleChangeView();
                              }}
                            >
                              <div
                                className="thumbnails__item-content"
                                title="Product Dimension"
                              >
                                <img
                                  src={process.env.PUBLIC_URL + "/asset/images/dimension_icon.svg"}
                                  alt="Schneider Eletric MH50"
                                  className="thumbnails__item-image"
                                />
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {productData?.MAIN_IMAGE_OF_PRODUCT || productData?.Image_Url ? (
                            <div
                              className={
                                renderView === "image"
                                  ? "thumbnails__item-content--active "
                                  : "thumbnails__wrapper"
                              }
                              onClick={() => {
                                handleChangeView();
                                setRenderView("image");
                              }}
                            >
                              <div
                                className="thumbnails__item-content"
                                title="Product Image"
                              >
                                <img
                                  loading="lazy"
                                  src={
                                    productData?.Image_Url
                                      ? productData?.Image_Url
                                      : productData?.MAIN_IMAGE_OF_PRODUCT
                                  }
                                  alt="Schneider Eletric MH50"
                                  className="thumbnails__item-image"
                                />
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {productData.VIEW_360_SET_OF_IMAGE &&
                            productData.VIEW_360_SET_OF_IMAGE[0] ? (
                            <div
                              className={
                                renderView === "360view"
                                  ? "thumbnails__item-content--active "
                                  : "thumbnails__wrapper"
                              }
                              onClick={() => {
                                handleChangeView();
                                setRenderView("360view");
                              }}
                            >
                              <div
                                className="thumbnails__item-content"
                                title="Product 360 Image"
                              >
                                <img
                                  loading="lazy"
                                  src={process.env.PUBLIC_URL + "/asset/images/360d-icon.svg"}
                            
                                  alt="Schneider Eletric MH50"
                                  className="thumbnails__item-image"
                                />
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {productData?.TECHNICAL_DIAGRAM &&
                            productData?.TECHNICAL_DIAGRAM[0] ? (
                            <div
                              className={
                                renderView === "WiringDiagram"
                                  ? "thumbnails__item-content--active "
                                  : "thumbnails__wrapper"
                              }
                              onClick={() => {
                                setRenderView("WiringDiagram");
                                handleChangeView();
                              }}
                            >
                              <div
                                className="thumbnails__item-content"
                                title="Wiring Diagram"
                              >
                                <img
                                  src={process.env.PUBLIC_URL + "/asset/images/wiring-diagram_icon.svg"}
                                  alt="Schneider Eletric MH50"
                                  className="thumbnails__item-image"
                                />
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {productData?.TECHNICAL_DIAGRAM_FETURES &&
                            productData?.TECHNICAL_DIAGRAM_FETURES[0] ? (
                            <div
                              className={
                                renderView === "TechnicalFetures"
                                  ? "thumbnails__item-content--active "
                                  : "thumbnails__wrapper"
                              }
                              onClick={() => {
                                setRenderView("TechnicalFetures");
                                handleChangeView();
                              }}
                            >
                              <div
                                className="thumbnails__item-content"
                                title="Wiring Diagram"
                              >
                                <img
                                  src={
                                    productData?.TECHNICAL_DIAGRAM_FETURES &&
                                      productData?.TECHNICAL_DIAGRAM_FETURES[0]
                                      ? productData?.TECHNICAL_DIAGRAM_FETURES &&
                                      productData
                                        ?.TECHNICAL_DIAGRAM_FETURES[0]
                                      : ""
                                  }
                                  alt="Schneider Eletric MH50"
                                  className="thumbnails__item-image"
                                />
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {productData.DatasheetObj ? (
                            <div
                              className={
                                renderView === "ProductInfo"
                                  ? "thumbnails__item-content--active "
                                  : "thumbnails__wrapper"
                              }
                              onClick={() => {
                                setRenderView("ProductInfo");
                                handleChangeView();
                              }}
                            >
                              <div
                                className="thumbnails__item-content"
                                title="Product Datasheet"
                              >
                                <img
                                  src={process.env.PUBLIC_URL + "/asset/images/files.png"}
                                  alt="Schneider Eletric MH50"
                                  className="thumbnails__item-image"
                                />
                              </div>{" "}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            </Typography>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
